import { QueryFunction } from '@tanstack/react-query';
import queryString from 'query-string';
import { CustomParamsSerializer } from 'axios';

import { useRecentActivityHistory } from '@app/components';
import { useFeatureFlag } from '@app/hooks';
import { makeRequest } from '@app/utils';
import { Feature } from '@app/constants';

import { getCQLState } from '../utils';
import { SearchResultsDto, SearchState } from '../constants';
import { useUrlManager } from './useUrlManager';

export const fetchSearch = (searchState: SearchState, expandAll = false) =>
  makeRequest<SearchResultsDto>({
    url: '/search/instances',
    params: {
      expandAll,
      ...getCQLState(searchState),
    },
    paramsSerializer: queryString.stringify as CustomParamsSerializer,
  }).catch(error => {
    throw error?.response?.data;
  });

export const useSearchRequest = (
  state: SearchState
): QueryFunction<SearchResultsDto> => {
  const { updateUrl } = useUrlManager();
  const { isActive: isConsortiaLogin } = useFeatureFlag({
    name: Feature.consortiaLoginFlow,
  });
  const { addSearchHistoryEntry } = useRecentActivityHistory();

  return ({ queryKey }) => {
    const searchState = queryKey[1] as SearchState;

    if (!state.isInnerUpdate) {
      updateUrl(searchState);
    }

    const result = fetchSearch(
      { ...searchState, isConsortiaMode: isConsortiaLogin },
      true
    );

    result
      .then(res => {
        if (state.pageNumber === 1 && !state.isNewPageRequest) {
          addSearchHistoryEntry(state, res.totalRecords);
        }
      })
      .catch(error => error);

    return result;
  };
};
